import { useEffect, useState } from 'react';
import { PARTNER_REFERER } from '@/constants/common.constants';
import { $sessionStorage } from '@tajawal/web-core-sdk-v2/lib/services/session-storage.service';

export function usePartnerReferer(): string {
  const [partnerReferer, setPartnerReferer] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.has(PARTNER_REFERER)) {
      $sessionStorage.set(PARTNER_REFERER, params.get(PARTNER_REFERER));
    }
    setPartnerReferer($sessionStorage.get(PARTNER_REFERER));
  }, []);

  return partnerReferer;
}
